/**
 * States plainly the one thing a reader will otherwise assume wrongly about a
 * screen called "Across portfolios" (figure S7). A standing statement, not a
 * dismissible banner — nobody may hide the line that stops them misreading
 * the screen.
 */
export default function AcrossStandingLine() {
  return (
    <p
      data-part="AcrossStandingLine"
      className="mb-4 rounded-lg border-l-4 border-iflow-500 bg-iflow-50/70 px-4 py-3 text-[13px] leading-relaxed text-iflow-900"
    >
      <b>There is no cross-portfolio matching.</b> Nothing here comes from another
      organisation&apos;s portfolio — only what they consented to share with your entities, at the
      rung they chose.
    </p>
  )
}
